import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// eslint-disable-next-line import/no-named-as-default-member
const i18n = i18next.createInstance();
i18n

  .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    debug: false,

    preload: ['en', 'de'],
    defaultNS: 'global',
    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    detection: {
      order: ['navigator'],

      caches: [],
    },
  });

export default i18n;
